import { createI18n } from 'vue-i18n';

// 1. Intentamos obtener el idioma guardado
const savedLocale = localStorage.getItem('user_lang');
// Detectamos el idioma del sistema (ej: 'es-ES' -> 'es')
const systemLocale = navigator.language.split('-')[0];

const messages = {
  es: {
    // Español
user: {
  profile_setup_title: 'Configura tu perfil',
  profile_setup_subtitle: 'Tu información aparecerá cuando comentes.',
  name: 'Nombre',
  age: 'Edad',
  start_participating: 'Comenzar a participar',
  save_capture: 'Guardar captura',
  loading: 'Cargando...',
  exit: 'Salir',
  live: 'EN VIVO',
  join_session: 'Únete a una sesión',
  enter_pin: 'Ingresa el pin de 4 dígitos',
  code: 'Código',
  enter: 'Entrar',
  recent_sessions: 'Sesiones recientes',
  answer_correct: 'RESPUESTA CORRECTA',
  winning_answer: 'La respuesta ganadora es:',
  points_earned: 'PUNTOS OBTENIDOS',
  almost: '¡Casi lo logras!',
  next_time: '¡Suerte en la próxima!',
  vote_registered: '¡Voto registrado!',
  watch_main_screen: 'Mira la pantalla principal para ver si ganaste.',
  received: '¡Recibido!',
  thanks_for_answer: 'Gracias por tu respuesta en {session}',
  paused_time: 'TIEMPO PAUSADO',
  how_are_you: '¿Cómo vas? ¡Reacciona!',
  ordering: 'ORDENAR',
  quiz_live: 'QUIZ EN CURSO',
  select_answer_now: '¡Selecciona tu respuesta ahora!',
  time_up: '¡TIEMPO AGOTADO!',
  answer_not_received: 'No logramos recibir tu respuesta a tiempo.',
  check_main_screen: 'Mira la pantalla principal para conocer la respuesta correcta',
  multiple: 'MÚLTIPLE',
  live_tag: 'LIVE',
  write_here: 'Escribe aquí...',
  sending: 'Enviando...',
  send_participation: 'Enviar participación',
  moments_cta: 'Comparte un moment',
  moments_instruction: 'Sube una foto y compártela con una frase breve, clara y afirmativa.',
  select_image: 'Seleccionar imagen',
  processing_photo: 'Procesando foto...',
  moments_placeholder: 'Ej. Hoy elegimos una pausa con energía, foco y buena actitud.',
  publishing_moment: 'Subiendo momento...',
  publish_moment: 'Publicar momento',
  moment_ready: 'Tu momento quedó listo para proyección.',
  moment_waiting: 'Tu foto aparecerá en pantalla cuando el administrador proyecte los moments.',
  connected_to: 'Conectado a',
  listening_changes: 'Escuchando cambios...',
  language: 'Idioma',
  ai_launcher: '¿Tienes alguna duda?',
  ai_title: 'Consultas al Expositor',
  ai_subtitle: 'Responderé a todo lo relacionado con el evento',
  ai_help_title: '¿En qué puedo ayudarte?',
  ai_help_subtitle: 'Pregúntame lo que quieras sobre la sesión. Aquí tienes unas recomendaciones:',
  main_topic: 'Tema principal',
  schedule: 'Horarios',
  summary: 'Resumen',
  tip_prefix: 'Tip:',
  tip_text: 'Sé específico para obtener mejores respuestas.'
},
proyector: {
  votos: "Votos",
  conectar_audio: "Conectar audio",
  proyecta_sesion: 'Proyecta tu sesión',
  escanea_pin: 'Escanea el código QR o ingresa el PIN en tu dispositivo',
  codigo_enlace: 'CÓDIGO DE ENLACE',
  derechos: 'Todos los derechos reservados',
  en_vivo: 'EN VIVO',
  sala: 'SALA',
  sesion_activa: 'Sesión Activa',
  esperando_inicio: 'Esperando el inicio de la actividad...',
  cargando_presentacion: 'Cargando presentación...',
  organizado_por: 'Organizado por',
  unete: '¡ÚNETE!',
  unete_a: 'ÚNETE A',
  la_sesion: 'LA SESIÓN',
  codigo: 'CÓDIGO',
  sala_espera_activa: 'SALA DE ESPERA ACTIVA',
  unete_sesion: 'Únete a la sesión',
  instrucciones_tv: 'Escanea el código para participar en tiempo real, enviar reacciones y responder preguntas. ¡Todo desde tu teléfono!',
  ingresa_en: 'O ingresa en',
  codigo_acceso: 'CÓDIGO DE ACCESO',
  lo_puso_primero: 'lo puso de #1',
  score: 'Puntaje',
  voto_por: 'Votó por',
  anonimo: 'Anónimo',
  salir_fs: 'Salir de pantalla completa',
  entrar_fs: 'Pantalla completa',
  cerrar_sesion: 'Cerrar sesión'
}
  
  }, // Lo iremos llenando



  en: {
   // Inglés
user: {
  profile_setup_title: 'Set up your profile',
  profile_setup_subtitle: 'Your information will appear when you comment.',
  name: 'Name',
  age: 'Age',
  start_participating: 'Start participating',
  save_capture: 'Save capture',
  loading: 'Loading...',
  exit: 'Exit',
  live: 'LIVE',
  join_session: 'Join a session',
  enter_pin: 'Enter the 4-digit pin',
  code: 'Code',
  enter: 'Enter',
  recent_sessions: 'Recent sessions',
  answer_correct: 'CORRECT ANSWER',
  winning_answer: 'The winning answer is:',
  points_earned: 'POINTS EARNED',
  almost: 'So close!',
  next_time: 'Better luck next time!',
  vote_registered: 'Vote recorded!',
  watch_main_screen: 'Look at the main screen to see if you won.',
  received: 'Received!',
  thanks_for_answer: 'Thanks for your answer in {session}',
  paused_time: 'TIME PAUSED',
  how_are_you: 'How are you doing? React!',
  ordering: 'ORDER',
  quiz_live: 'QUIZ LIVE',
  select_answer_now: 'Choose your answer now!',
  time_up: 'TIME IS UP!',
  answer_not_received: 'We could not receive your answer in time.',
  check_main_screen: 'Check the main screen to see the correct answer',
  multiple: 'MULTIPLE',
  live_tag: 'LIVE',
  write_here: 'Write here...',
  sending: 'Sending...',
  send_participation: 'Send participation',
  moments_cta: 'Share a moment',
  moments_instruction: 'Upload a photo and pair it with a short, clear and affirmative sentence.',
  select_image: 'Select image',
  processing_photo: 'Processing photo...',
  moments_placeholder: 'Ex. Today we choose a pause with energy, focus and good attitude.',
  publishing_moment: 'Uploading moment...',
  publish_moment: 'Publish moment',
  moment_ready: 'Your moment is ready for projection.',
  moment_waiting: 'Your photo will appear on screen when the admin projects the moments.',
  connected_to: 'Connected to',
  listening_changes: 'Listening for changes...',
  language: 'Language',
  ai_launcher: 'Do you have any questions?',
  ai_title: 'Questions for the speaker',
  ai_subtitle: 'I will answer everything related to the event',
  ai_help_title: 'How can I help you?',
  ai_help_subtitle: 'Ask me anything about the session. Here are some recommendations:',
  main_topic: 'Main topic',
  schedule: 'Schedule',
  summary: 'Summary',
  tip_prefix: 'Tip:',
  tip_text: 'Be specific to get better answers.'
},
proyector: {
  votos: "Votes",
  conectar_audio: "Connect audio",
  proyecta_sesion: 'Project your session',
  escanea_pin: 'Scan the QR code or enter the PIN on your device',
  codigo_enlace: 'LINK CODE',
  derechos: 'All rights reserved',
  en_vivo: 'LIVE',
  sala: 'ROOM',
  sesion_activa: 'Active Session',
  esperando_inicio: 'Waiting for the activity to start...',
  cargando_presentacion: 'Loading presentation...',
  organizado_por: 'Organized by',
  unete: 'JOIN US!',
  unete_a: 'JOIN THE',
  la_sesion: 'SESSION',
  codigo: 'CODE',
  sala_espera_activa: 'WAITING ROOM ACTIVE',
  unete_sesion: 'Join the session',
  instrucciones_tv: 'Scan the code to participate in real-time, send reactions and answer questions. All from your phone!',
  ingresa_en: 'Or enter at',
  codigo_acceso: 'ACCESS CODE',
  lo_puso_primero: 'ranked it #1',
  score: 'Score',
  voto_por: 'Voted for',
  anonimo: 'Anonymous',
  salir_fs: 'Exit fullscreen',
  entrar_fs: 'Fullscreen',
  cerrar_sesion: 'Log out'
}
  }, 

  
  pt: {
    // Portugués
user: {
  profile_setup_title: 'Configure seu perfil',
  profile_setup_subtitle: 'Suas informações aparecerão quando você comentar.',
  name: 'Nome',
  age: 'Idade',
  start_participating: 'Começar a participar',
  save_capture: 'Salvar captura',
  loading: 'Carregando...',
  exit: 'Sair',
  live: 'AO VIVO',
  join_session: 'Participe de uma sessão',
  enter_pin: 'Digite o PIN de 4 dígitos',
  code: 'Código',
  enter: 'Entrar',
  recent_sessions: 'Sessões recentes',
  answer_correct: 'RESPOSTA CORRETA',
  winning_answer: 'A resposta vencedora é:',
  points_earned: 'PONTOS OBTIDOS',
  almost: 'Quase conseguiu!',
  next_time: 'Boa sorte na próxima!',
  vote_registered: 'Voto registrado!',
  watch_main_screen: 'Olhe para a tela principal para ver se você ganhou.',
  received: 'Recebido!',
  thanks_for_answer: 'Obrigado pela sua resposta em {session}',
  paused_time: 'TEMPO PAUSADO',
  how_are_you: 'Como você está? Reaja!',
  ordering: 'ORDENAR',
  quiz_live: 'QUIZ AO VIVO',
  select_answer_now: 'Selecione sua resposta agora!',
  time_up: 'TEMPO ESGOTADO!',
  answer_not_received: 'Não conseguimos receber sua resposta a tempo.',
  check_main_screen: 'Veja a tela principal para conhecer a resposta correta',
  multiple: 'MÚLTIPLA',
  live_tag: 'LIVE',
  write_here: 'Escreva aqui...',
  sending: 'Enviando...',
  send_participation: 'Enviar participação',
  moments_cta: 'Compartilhe um momento',
  moments_instruction: 'Envie uma foto e acompanhe com uma frase curta, clara e afirmativa.',
  select_image: 'Selecionar imagem',
  processing_photo: 'Processando foto...',
  moments_placeholder: 'Ex. Hoje escolhemos uma pausa com energia, foco e boa atitude.',
  publishing_moment: 'Enviando momento...',
  publish_moment: 'Publicar momento',
  moment_ready: 'Seu momento está pronto para projeção.',
  moment_waiting: 'Sua foto aparecerá na tela quando o administrador projetar os moments.',
  connected_to: 'Conectado a',
  listening_changes: 'Escutando mudanças...',
  language: 'Idioma',
  ai_launcher: 'Tem alguma dúvida?',
  ai_title: 'Perguntas ao apresentador',
  ai_subtitle: 'Responderei tudo relacionado ao evento',
  ai_help_title: 'Como posso ajudar?',
  ai_help_subtitle: 'Pergunte o que quiser sobre a sessão. Aqui estão algumas recomendações:',
  main_topic: 'Tema principal',
  schedule: 'Horários',
  summary: 'Resumo',
  tip_prefix: 'Dica:',
  tip_text: 'Seja específico para obter respostas melhores.'
},
proyector: {
  conectar_audio: "Conectar áudio",
  proyecta_sesion: 'Projete sua sessão',
  escanea_pin: 'Escaneie o código QR ou insira o PIN no seu dispositivo',
  codigo_enlace: 'CÓDIGO DE LINK',
  derechos: 'Todos os direitos reservados',
  en_vivo: 'AO VIVO',
  sala: 'SALA',
  sesion_activa: 'Sessão Ativa',
  esperando_inicio: 'Aguardando o início da atividade...',
  cargando_presentacion: 'Carregando apresentação...',
  organizado_por: 'Organizado por',
  unete: 'PARTICIPE!',
  unete_a: 'PARTICIPE DA',
  la_sesion: 'SESSÃO',
  codigo: 'CÓDIGO',
  sala_espera_activa: 'SALA DE ESPERA ATIVA',
  unete_sesion: 'Participe da sessão',
  instrucciones_tv: 'Escaneie o código para participar em tempo real, enviar reações e responder perguntas. Tudo pelo seu celular!',
  ingresa_en: 'Ou acesse em',
  codigo_acceso: 'CÓDIGO DE ACESSO',
  lo_puso_primero: 'colocou em #1',
  score: 'Pontuação',
  voto_por: 'Votou em',
  anonimo: 'Anônimo',
  salir_fs: 'Sair da tela cheia',
  entrar_fs: 'Tela cheia',
  cerrar_sesion: 'Encerrar sessão'
}
  }  // Lo iremos llenando
};


const supportedLocales = ['es', 'en', 'pt'];
const initialLocale = supportedLocales.includes(savedLocale)
  ? savedLocale
  : (supportedLocales.includes(systemLocale) ? systemLocale : 'en');


const i18n = createI18n({
  legacy: false, 
  locale: initialLocale,
  fallbackLocale: 'en', //si el idioma es un idioma extraño usamos ingle por defecto.
  messages,
});

export default i18n;
